import { render, staticRenderFns } from "./PersonnelOverview_StatementOfCosts.vue?vue&type=template&id=668c2cce&scoped=true&"
import script from "./PersonnelOverview_StatementOfCosts.vue?vue&type=script&lang=js&"
export * from "./PersonnelOverview_StatementOfCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c2cce",
  null
  
)

export default component.exports